import { NgModule } from '@angular/core';
import { RibbonService } from './ribbon.service';

@NgModule({
  providers: [ RibbonService ]
})
export class RibbonModule {}
